import React, { ReactNode } from 'react';
import { Layout } from 'antd';

import './index.less';

import { ElmaCortexFullLogo } from '../../assets';
import IbIcon from '../../components/common/IbIcon';

import {
  CONTENT_CLASS_NAME,
  CORTEX_LOGO_HEIGHT,
  CORTEX_LOGO_WIDTH,
  DESCRIPTION_CLASS_NAME,
  FRAME_CLASS_NAME,
  LOGO_CONTAINER_CLASS_NAME,
  MAIN_CLASS_NAME,
  TITLE_CLASS_NAME,
} from './const';

const { Content } = Layout;

interface IProps {
  title: string;
  description: ReactNode;
  logoHref?: string;
}

const ErrorLayout: React.FC<IProps> = ({ title, description }) => {
  return (
    <Layout className={MAIN_CLASS_NAME}>
      <div className={LOGO_CONTAINER_CLASS_NAME}>
        <ElmaCortexFullLogo height={CORTEX_LOGO_HEIGHT} width={CORTEX_LOGO_WIDTH} />
      </div>
      <Content className={CONTENT_CLASS_NAME}>
        <div className={FRAME_CLASS_NAME}>
          <IbIcon iconName="close-one" />
          <div className={TITLE_CLASS_NAME}>{title}</div>
          <div className={DESCRIPTION_CLASS_NAME}>{description}</div>
        </div>
      </Content>
    </Layout>
  );
};

export default ErrorLayout;
